"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Funnel = require("./Funnel.styled");

var _schemes = require("../schemes");

var _Theme = require("../Themes/Theme");

var _text = require("@visx/text");

var _components = require("@dentsu-ui/components");

var _chromaJs = _interopRequireDefault(require("chroma-js"));

var _tokens = require("@dentsu-ui/tokens");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["theme", "direction", "colors", "luminanceComparitor", "interpolation", "spacing", "shapeBlending", "fillOpacity", "borderWidth", "enableBeforeSeparators", "enableAfterSeparators", "beforeSeparatorLength", "beforeSeparatorOffset", "afterSeparatorLength", "afterSeparatorOffset"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Funnel(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _objectSpread(_objectSpread({}, _Theme.StyledTheme), {}, {
    labels: _objectSpread(_objectSpread({}, _Theme.StyledTheme.labels), {}, {
      text: {
        fontSize: '1rem'
      }
    })
  }) : _ref$theme,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? 'blue' : _ref$colors,
      _ref$luminanceCompari = _ref.luminanceComparitor,
      luminanceComparitor = _ref$luminanceCompari === void 0 ? null : _ref$luminanceCompari,
      _ref$interpolation = _ref.interpolation,
      interpolation = _ref$interpolation === void 0 ? 'linear' : _ref$interpolation,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 1 : _ref$spacing,
      _ref$shapeBlending = _ref.shapeBlending,
      shapeBlending = _ref$shapeBlending === void 0 ? 0 : _ref$shapeBlending,
      _ref$fillOpacity = _ref.fillOpacity,
      fillOpacity = _ref$fillOpacity === void 0 ? 1 : _ref$fillOpacity,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 0 : _ref$borderWidth,
      _ref$enableBeforeSepa = _ref.enableBeforeSeparators,
      enableBeforeSeparators = _ref$enableBeforeSepa === void 0 ? true : _ref$enableBeforeSepa,
      _ref$enableAfterSepar = _ref.enableAfterSeparators,
      enableAfterSeparators = _ref$enableAfterSepar === void 0 ? true : _ref$enableAfterSepar,
      _ref$beforeSeparatorL = _ref.beforeSeparatorLength,
      beforeSeparatorLength = _ref$beforeSeparatorL === void 0 ? 100 : _ref$beforeSeparatorL,
      _ref$beforeSeparatorO = _ref.beforeSeparatorOffset,
      beforeSeparatorOffset = _ref$beforeSeparatorO === void 0 ? 0 : _ref$beforeSeparatorO,
      _ref$afterSeparatorLe = _ref.afterSeparatorLength,
      afterSeparatorLength = _ref$afterSeparatorLe === void 0 ? 0 : _ref$afterSeparatorLe,
      _ref$afterSeparatorOf = _ref.afterSeparatorOffset,
      afterSeparatorOffset = _ref$afterSeparatorOf === void 0 ? 0 : _ref$afterSeparatorOf,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var calculateLabelColour = function calculateLabelColour(data) {
    var comparitor;

    if (colors === 'blue') {
      comparitor = _tokens.ColorBlue;
    } else if (colors === 'purple') {
      comparitor = _tokens.ColorPurple;
    } else {
      comparitor = luminanceComparitor;
    }

    if (!comparitor) {
      return _tokens.ColorBlack;
    }

    if ((0, _chromaJs["default"])(data.color).luminance() >= (0, _chromaJs["default"])(comparitor).luminance()) {
      return _tokens.ColorBlack;
    }

    return _tokens.ColorWhite;
  };

  return (0, _jsxRuntime.jsx)(_Funnel.StyledFunnel, _objectSpread({
    theme: theme,
    direction: direction,
    colors: colors === 'blue' ? _schemes.blue : colors === 'purple' ? _schemes.purple : colors,
    interpolation: interpolation,
    shapeBlending: shapeBlending,
    borderWidth: borderWidth,
    fillOpacity: fillOpacity,
    enableBeforeSeparators: enableBeforeSeparators,
    enableAfterSeparators: enableAfterSeparators,
    beforeSeparatorLength: beforeSeparatorLength,
    beforeSeparatorOffset: beforeSeparatorOffset,
    afterSeparatorLength: afterSeparatorLength,
    afterSeparatorOffset: afterSeparatorOffset,
    spacing: spacing,
    labelColor: calculateLabelColour,
    layers: ['separators', 'parts', 'labels', 'annotations', function (data) {
      if (data.beforeSeparators && data.beforeSeparators.length && props.data.length) {
        return data.beforeSeparators.map(function (seperator, index) {
          var dataIndex = props.data.findIndex(function (data) {
            return data.id === seperator.partId;
          });
          var partIndex = data.parts.findIndex(function (part) {
            return part.data.id === seperator.partId;
          });

          if (partIndex === -1) {
            return null;
          }

          return (0, _jsxRuntime.jsx)(_text.Text, {
            textAnchor: direction !== 'vertical' ? 'middle' : undefined,
            verticalAnchor: direction !== 'vertical' ? 'start' : undefined,
            style: {
              color: _tokens.ColorGrey,
              fontSize: '1rem'
            },
            width: direction !== 'vertical' ? data.parts[partIndex].width - 20 : undefined,
            x: direction === 'vertical' ? seperator.x0 : data.parts[partIndex].x,
            y: direction === 'vertical' ? data.parts[partIndex].height / 2 + seperator.y0 : 5,
            y1: seperator.y1,
            children: props.data[dataIndex].label
          }, index);
        });
      }
    }, function (data) {
      if (data.afterSeparators && data.afterSeparators.length && props.data.length) {
        return data.afterSeparators.map(function (seperator, index) {
          var partIndex = data.parts.findIndex(function (part) {
            return part.data.id === seperator.partId;
          });

          if (index === 0 || partIndex === -1) {
            return null;
          }

          var incrementState = '';

          if (data.parts[partIndex - 1].data.value > data.parts[partIndex].data.value) {
            incrementState = 'loss';
          }

          if (data.parts[partIndex - 1].data.value === data.parts[partIndex].data.value) {
            incrementState = 'neutral';
          }

          if (data.parts[partIndex - 1].data.value < data.parts[partIndex].data.value) {
            incrementState = 'gain';
          }

          var percentageChange = (data.parts[partIndex].data.value - data.parts[partIndex - 1].data.value) / data.parts[partIndex - 1].data.value;
          return (0, _jsxRuntime.jsx)("foreignObject", {
            x: direction === 'vertical' ? seperator.x1 - 100 : seperator.x1 - 50,
            y: direction === 'vertical' ? seperator.y0 - 14 : seperator.y1 - 25,
            width: "100",
            height: "100",
            children: (0, _jsxRuntime.jsx)("div", {
              style: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end'
              },
              children: (0, _jsxRuntime.jsxs)(_components.Paragraph, {
                style: {
                  color: _tokens.ColorGrey,
                  fontSize: '1rem',
                  borderRadius: '30px',
                  background: _tokens.ColorN150,
                  padding: '4px 8px',
                  display: 'flex',
                  alignItems: 'center',
                  width: direction === 'vertical' ? 'auto' : '100%',
                  justifyContent: direction === 'vertical' ? 'initial' : 'center'
                },
                children: [(0, _jsxRuntime.jsx)(_components.FormatNumber, {
                  value: percentageChange,
                  format: "percent"
                }), incrementState !== 'neutral' ? (0, _jsxRuntime.jsx)(_components.Icon, {
                  size: 16,
                  icon: incrementState === 'loss' ? 'caret-down' : 'caret-up',
                  color: incrementState === 'loss' ? _tokens.ColorRed : _tokens.ColorGreen
                }) : null]
              })
            })
          }, index);
        });
      }
    }]
  }, props));
}

Funnel.defaultProps = {};
Funnel.displayName = 'Funnel';
var _default = Funnel;
exports["default"] = _default;